export const getPriceList = (latitude, longitude, apiPrices) => {
    const isOutsideIndia = latitude && longitude && (
        latitude < 8.4 || latitude > 37.6 || longitude < 68.7 || longitude > 97.25
    ); // More accurate bounds for India

    // Define GST (let's assume 18% for this example)
    const GST = 0.18;
    const formatPriceWithCurrency = (price, currency) => {
        return currency === 'USD' ? `$${price}` : `₹${price}`;
    };

    const getValuePackPrice = (packName) => {
        return {
            price: formatPriceWithCurrency(
                isOutsideIndia ? (apiPrices["Value Pack"]?.[packName]?.USD || 0) : (apiPrices["Value Pack"]?.[packName]?.INR || 0),
                isOutsideIndia ? 'USD' : 'INR'
            )
        };
    };

    const getSubscriptionPackPrice = (period, packName) => {
        return {
            price: formatPriceWithCurrency(
                isOutsideIndia ? (apiPrices["Subscription Pack"]?.[period]?.[packName]?.USD || 0) : (apiPrices["Subscription Pack"]?.[period]?.[packName]?.INR || 0),
                isOutsideIndia ? 'USD' : 'INR'
            )
        };
    };

    return {

        "Digital Image": {
            price: formatPriceWithCurrency(isOutsideIndia ? (apiPrices?.["Digital Image"]?.USD || 3.3) : (apiPrices?.["Digital Image"]?.INR || 200),
                isOutsideIndia ? 'USD' : 'INR'
            )
        },

        "Print Image": {
            price: formatPriceWithCurrency(isOutsideIndia ? (apiPrices?.["Print Image"]?.USD || 33) : (apiPrices?.["Print Image"]?.INR || 2000),
                isOutsideIndia ? 'USD' : 'INR'
            )
        },

        "Super Saver": {
            price: formatPriceWithCurrency(isOutsideIndia ? (apiPrices?.["Super Saver"]?.USD || 2) : (apiPrices?.["Super Saver"]?.INR || 100),
                isOutsideIndia ? 'USD' : 'INR'
            )
        },

        "Sub Total": {
            price: formatPriceWithCurrency(isOutsideIndia ? (apiPrices?.["Sub Total"]?.USD || 0) : (apiPrices?.["Sub Total"]?.INR || 0),
                isOutsideIndia ? 'USD' : 'INR'
            )
        },
        "Discount": {
            price: formatPriceWithCurrency(isOutsideIndia ? (apiPrices?.["Discount"]?.USD || 0) : (apiPrices?.["Discount"]?.INR || 0),
                isOutsideIndia ? 'USD' : 'INR'
            )
        },

        "GST": {
            price: formatPriceWithCurrency(isOutsideIndia ? (apiPrices?.["GST"]?.USD || 0) : (apiPrices?.["GST"]?.INR || 0),
                isOutsideIndia ? 'USD' : 'INR'
            )
        },
        "Total": {
            price: formatPriceWithCurrency(isOutsideIndia ? (apiPrices?.["Total"]?.USD || 0) : (apiPrices?.["Total"]?.INR || 0),
                isOutsideIndia ? 'USD' : 'INR'
            )
        },

        "Value Pack - 3 Credits": getValuePackPrice("3 Credits"),
        "Value Pack - 10 Credits": getValuePackPrice("10 Credits"),
        "Value Pack - 25 Credits": getValuePackPrice("25 Credits"),
        "Value Pack - 100 Credits": getValuePackPrice("100 Credits"),
        "Value Pack - 250 Credits": getValuePackPrice("250 Credits"),
        "Subscription Pack - Monthly - 50 Credits": getSubscriptionPackPrice("Monthly", "50 Credits"),
        "Subscription Pack - Monthly - 150 Credits": getSubscriptionPackPrice("Monthly", "150 Credits"),
        "Subscription Pack - Monthly - 350 Credits": getSubscriptionPackPrice("Monthly", "350 Credits"),
        "Subscription Pack - Quarterly - 50 Credits": getSubscriptionPackPrice("Quarterly", "50 Credits"),
        "Subscription Pack - Quarterly - 150 Credits": getSubscriptionPackPrice("Quarterly", "150 Credits"),
        "Subscription Pack - Quarterly - 350 Credits": getSubscriptionPackPrice("Quarterly", "350 Credits"),



        // Add other products similarly, using apiPrices or fallback to hardcoded values
    };


};


export default getPriceList;
